import React from 'react';
import './dotSpinStyles.css';
import CircularProgress from '@material-ui/core/CircularProgress';

const DotSpinLoader = () =>
{
	return (
		<div className='loaderCntnr internalLoader'>
			{/* <div className='snippet' data-title='.dot-spin'>
				<div className='stage'>
					<div className='dot-spin' />
				</div>
			</div> */}
			<CircularProgress/>
		</div>
	);
};

export default DotSpinLoader;
